import { render } from "./user-grid.vue?vue&type=template&id=644a59aa"
import script from "./user-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./user-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/user-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "644a59aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('644a59aa', __exports__)) {
    api.reload('644a59aa', __exports__)
  }
  
  module.hot.accept("./user-grid.vue?vue&type=template&id=644a59aa", () => {
    api.rerender('644a59aa', render)
  })

}


export default __exports__